module.exports = __webpack_public_path__ + "img/websiteProjectWhite.41ad9c0f.svg";